import { encodePaginatableQuery, encodeSortableQuery, PaginatableQuery, Query, SortableQuery } from '@/services/api';
import * as q from '@/services/api/request/query';

export interface ScheduleQuery extends PaginatableQuery, SortableQuery {
  search: string;
  entities: number[];
  assignees: number[];
  checklists: number[];
}

export const encodeScheduleQuery = (query: ScheduleQuery): Query => ({
  ...encodePaginatableQuery(query),
  search: q.string(query.search),
  entities: q.numbers(query.entities),
  assignees: q.numbers(query.assignees),
  checklists: q.numbers(query.checklists),
  ...encodeSortableQuery(query),
});
